export async function fetchChangeTariff(obj: {
  tariffId?: string
  businessParameterValue?: string
}) {
  const route = useRoute()
  const locale = route.params.locale as string

  return await $fetch
    .raw('/customer/tariff/change', {
      server: false,
      method: 'PUT',
      credentials: 'include',
      baseURL: useRuntimeConfig().public.apiBaseURL,
      body: {
        tariffId: obj.tariffId,
        businessParameterValue: obj.businessParameterValue,
        language: locale,
        client: useRuntimeConfig().public.client,
      },
      async onResponse(context) {
        if (context.response.status === 401) {
          await fetchRefreshToken()
          //@ts-ignore
          context.response = await $fetch.raw(context.request, context.options)
        }
      },
    })
    .catch((error) => {
      console.log(error.data)
      return error.data
    })
}
